const labels = {
  en: ['Open in WIW', 'Get the app', 'Continue in browser'],
  ru: ['Открыть в WIW', 'Скачать приложение', 'Продолжить в браузере'],
  es: ['Abrir en WIW', 'Descargar la aplicación', 'Continuar en el navegador'],
  fr: ['Ouvrir dans WIW', 'Télécharger l’application', 'Continuer dans le navigateur'],
  de: ['In WIW öffnen', 'App laden', 'Im Browser fortfahren'],
  it: ['Apri in WIW', 'Scarica l’app', 'Continua nel browser'],
  pt: ['Abrir no WIW', 'Baixar o aplicativo', 'Continuar no navegador'],
  tr: ['WIW’de aç', 'Uygulamayı indir', 'Tarayıcıda devam et'],
  ja: ['WIWで開く', 'アプリをダウンロード', 'ブラウザで続ける'],
  ko: ['WIW에서 열기', '앱 다운로드', '브라우저에서 계속'],
  zh: ['在 WIW 中打开', '下载应用', '继续使用浏览器'],
  hi: ['WIW में खोलें', 'ऐप डाउनलोड करें', 'ब्राउज़र में जारी रखें'],
};
export default labels;
